export default "__VITE_ASSET__PSObNS1J__"